import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
// import { LinkContainer } from 'react-router-bootstrap';
// import moment from 'moment';
import { Spinner, Card, CardBody, Table, CardHeader, Badge } from 'reactstrap';
// import LoaderButton from '../loader-button/LoaderButton';
import Switch from 'react-switch';
// import BzCardHeader from '../bz/BzCardHeader';
// import ButtonIcon from '../common/ButtonIcon';

// import { onError } from '../../libs/errorLib';
import Loader from '../common/Loader';
// import Loading from '../../components/Loading';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
import BZAPIService from '../../services/BZAPIService';
import Heading from '../common/Heading';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import { VendorsContext } from '../../context/VendorsContext';
import { TenantSettingsContext } from '../../context/TenantSettingsContext';
import TenantSettings from './TenantSettings';

export default function SuperAdmin() {
  const [appVersion, setAppVersion] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [vendorLoading, setVendorLoading] = useState('');
  const [bypassLoading, setBypassLoading] = useState('');
  const [vendorsLoadError, setVendorsLoadError] = useState(false);
  const [dashboardSectionsLoading, setDashboardSectionsLoading] = useState(false);
  const [productEnablement, setProductEnablement] = useState({ plan: true, prevent: true, predict: true });
  const [productLoading, setProductLoading] = useState('');
  const [featureEnablement, setFeatureEnablement] = useState({ bugCoverage: true });
  const [featureLoading, setFeatureLoading] = useState('');
  const [vendors, setVendors] = useContext(VendorsContext);
  const { setBugCoverageEnabled } = useContext(TenantSettingsContext);
  const [dashboardSections, setDashboardSections] = useState([
    { label: 'Integrations', value: 'displayIntegration', active: 1 },
    { label: 'Vendor Integrations', value: 'displayVendorIntegration', active: 1 },
    { label: 'Tenant Bug Stats', value: 'displayTenantBugStats', active: 1 },
    { label: 'ODD Bug stats', value: 'displayOddBugStats', active: 1 }
  ]);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        setVendorsLoadError(false);
        const vendorsData = await BZAPIService.getVendors();
        const appVersion = await BZAPIService.getAppVersion();
        setAppVersion(appVersion);
        setVendors(vendorsData);
      } catch (e) {
        console.log(e);
        setVendorsLoadError(true);
        setIsLoading(false);
      }
      try {
        const dashboard = await BZAPIService.getBzDashboard();
        const res = dashboard.data;
        setDashboardSections(isEmpty(res) ? dashboardSections : res.bugZeroDashboard.display);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
      try {
        const products = await BZAPIService.getProductEnablement();
        if (products) setProductEnablement(products);
      } catch (e) {
        console.log(e);
      }
      try {
        const features = await BZAPIService.getFeatureEnablement();
        if (features) setFeatureEnablement(features);
      } catch (e) {
        console.log(e);
      }

      setIsLoading(false);
    }

    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSwitchToggle(vendor) {
    const confirmed = window.confirm(
      `Are you sure you want to ${vendor.active ? 'disable' : 'enable'} ${vendor.name}?`
    );

    if (!confirmed || !vendor) {
      return;
    }

    vendor.active = !vendor.active;

    try {
      setVendorLoading(vendor.id);
      await BZAPIService.toggleVendor(vendor.id, vendor.active);
      const updatedVendors = await BZAPIService.getVendors();
      setVendors(updatedVendors);
      setVendorLoading('');
      toast.success(
        `${vendor.name} ${vendor.active ? 'enabled' : 'disabled'} successfully. Navbar will refresh automatically.`
      );
    } catch (e) {
      console.log(e);
      setVendorLoading('');
      toast.error('Failed to update vendor');
    }
  }

  async function handleSectionsToggle(section) {
    const confirm = window.confirm(
      `Are you sure you want to ${section.active ? 'disable' : 'enable'} ${section.label}?`
    );

    if (!confirm || !section) {
      return;
    }

    section.active = !section.active;
    section.active === false ? (section.active = 0) : (section.active = 1);
    console.log('section: ', section);
    setDashboardSections([...dashboardSections]);

    try {
      setDashboardSectionsLoading(section.value);
      const payload = {
        type: 'global',
        bugZeroDashboard: {
          display: dashboardSections
        }
      };
      await BZAPIService.postBzDashboard(payload);
      const sections = await BZAPIService.getBzDashboard();
      setDashboardSections(sections.data.bugZeroDashboard.display);
      setDashboardSectionsLoading('');
      toast.success(`${section.label} updated successfully.`);
    } catch (e) {
      console.log(e);
      setDashboardSectionsLoading('');
      toast.error('Failed to update section');
    }
  }

  async function handleProductToggle(productId, productLabel) {
    const current = productEnablement[productId];
    const confirmed = window.confirm(`Are you sure you want to ${current ? 'disable' : 'enable'} ${productLabel}?`);
    if (!confirmed) return;
    try {
      setProductLoading(productId);
      const updated = await BZAPIService.updateProductEnablement(productId, !current);
      if (updated) setProductEnablement(updated);
      toast.success(`${productLabel} ${!current ? 'enabled' : 'disabled'} successfully.`);
    } catch (e) {
      console.log(e);
      toast.error(`Failed to update ${productLabel}`);
    } finally {
      setProductLoading('');
    }
  }

  async function handleFeatureToggle(featureId, featureLabel) {
    const current = featureEnablement[featureId];
    const confirmed = window.confirm(`Are you sure you want to ${current ? 'disable' : 'enable'} ${featureLabel}?`);
    if (!confirmed) return;
    try {
      setFeatureLoading(featureId);
      const updated = await BZAPIService.updateFeatureEnablement(featureId, !current);
      if (updated) {
        setFeatureEnablement(updated);
        // Apply to the open session too, so the dashboard reflects it without a reload.
        if (featureId === 'bugCoverage') setBugCoverageEnabled(updated.bugCoverage !== false);
      }
      toast.success(`${featureLabel} ${!current ? 'enabled' : 'disabled'} successfully.`);
    } catch (e) {
      console.log(e);
      toast.error(`Failed to update ${featureLabel}`);
    } finally {
      setFeatureLoading('');
    }
  }

  function renderDashboardSections(dashboardSections) {
    return dashboardSections.map(section => {
      return (
        <tr key={section.value + '-row'}>
          <td style={{ padding: 0 }}>
            <p
              style={{
                display: 'inline-block',
                width: '100%',
                height: '100%',
                padding: '1em'
              }}
            >
              {section.label}
            </p>
          </td>
          <td>
            <div className="position-relative">
              <Switch
                onChange={() => handleSectionsToggle(section)}
                checked={section.active ? true : false}
                onColor="#253746"
              />
              <Spinner
                size="sm"
                className={`${section.value === dashboardSectionsLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
              />
            </div>
          </td>
        </tr>
      );
    });
  }

  async function handleBypassToggle(vendor) {
    const prevValue = vendor.vendorData?.bypassStatusIoCheck === true;
    const nextValue = !prevValue;

    const applyValue = value =>
      setVendors(prevVendors =>
        prevVendors.map(v =>
          v.id === vendor.id ? { ...v, vendorData: { ...(v.vendorData || {}), bypassStatusIoCheck: value } } : v
        )
      );

    applyValue(nextValue);
    setBypassLoading(vendor.id);

    try {
      await BZAPIService.updateVendorBypassStatusIo(vendor.id, nextValue);
      toast.success(`${vendor.name} status.io bypass ${nextValue ? 'enabled' : 'disabled'}.`);
    } catch (e) {
      console.log(e);
      applyValue(prevValue);
      toast.error(`Failed to update status.io bypass for ${vendor.name}.`);
    } finally {
      setBypassLoading('');
    }
  }

  function renderStatusIoBypassList(statusIoVendors) {
    return statusIoVendors.map(vendor => {
      const bypassActive = vendor.vendorData?.bypassStatusIoCheck === true;
      return (
        <tr
          key={vendor.id + '-bypass-row'}
          className={bypassActive ? 'table-warning' : ''}
          title={bypassActive ? 'status.io checks are being skipped for this vendor' : undefined}
        >
          <td style={{ padding: '1em' }}>{vendor.name}</td>
          <td>
            <div className="position-relative">
              <Switch
                onChange={() => handleBypassToggle(vendor)}
                checked={bypassActive}
                onColor="#253746"
                disabled={vendor.id === bypassLoading}
              />
              <Spinner
                size="sm"
                className={`${vendor.id === bypassLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
              />
            </div>
          </td>
          <td>
            {bypassActive ? (
              <Badge
                color="warning"
                pill
                title="status.io checks skipped; runs proceed regardless of status.io reports"
              >
                Bypass active — status.io checks skipped
              </Badge>
            ) : null}
          </td>
        </tr>
      );
    });
  }

  function renderVendorList(vendors, type) {
    return vendors
      ?.filter(vendor => vendor.type === type)
      .map(vendor => {
        if (vendor.id === 'servicenow') {
          return <></>;
        } else {
          return (
            <tr key={vendor.id + '-row'}>
              <td style={{ padding: 0 }}>
                <Link
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                    padding: '1em'
                  }}
                  key={vendor.id}
                  to={`/vendors/${vendor.id}/configuration`}
                >
                  {vendor.name}
                </Link>
              </td>

              <td>
                <div className="position-relative">
                  <Switch
                    onChange={() => handleSwitchToggle(vendor)}
                    checked={vendor.active ? true : false}
                    onColor="#253746"
                    // disabled={`${vendor.id === vendorLoading ? false : true}`}
                  />
                  <Spinner
                    size="sm"
                    className={`${vendor.id === vendorLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
                  />
                </div>
              </td>
            </tr>
          );
        }
      });
  }

  if (isLoading) return <Loader text="Loading..." />;

  const statusIoVendors = (vendors || []).filter(v => v?.vendorData?.statusIoConfig);

  return (
    <>
      <Heading title={'Super Admin'} subtitle={`Manage sections & vendors`} className="mb-4 mt-3" icon="list" />
      <Card className="mb-4">
        <CardHeader>BugZero App Version</CardHeader>
        <CardBody className="fs--1">
          <Table striped bordered hover style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Deployed version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{appVersion}</td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardHeader>Products</CardHeader>
        <CardBody className="fs--1">
          <Table striped bordered hover style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Product</th>
                <th>Enabled</th>
              </tr>
            </thead>
            <tbody>
              {[
                { id: 'plan', label: 'Plan' },
                { id: 'prevent', label: 'Prevent' },
                { id: 'predict', label: 'Predict' }
              ].map(p => (
                <tr key={p.id + '-product-row'}>
                  <td style={{ padding: '1em' }}>{p.label}</td>
                  <td>
                    <div className="position-relative">
                      <Switch
                        onChange={() => handleProductToggle(p.id, p.label)}
                        checked={!!productEnablement[p.id]}
                        onColor="#253746"
                        disabled={p.id === productLoading}
                      />
                      <Spinner
                        size="sm"
                        className={`${p.id === productLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardHeader>Features</CardHeader>
        <CardBody className="fs--1">
          <Table striped bordered hover style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Feature</th>
                <th>Enabled</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  id: 'bugCoverage',
                  label: 'Bug coverage',
                  description:
                    'Published, open and addressed bug counts on the Prevent dashboard and vendor configuration pages'
                }
              ].map(f => (
                <tr key={f.id + '-feature-row'}>
                  <td style={{ padding: '1em' }}>
                    <div>{f.label}</div>
                    <small className="text-muted">{f.description}</small>
                  </td>
                  <td>
                    <div className="position-relative">
                      <Switch
                        onChange={() => handleFeatureToggle(f.id, f.label)}
                        checked={featureEnablement[f.id] !== false}
                        onColor="#253746"
                        disabled={f.id === featureLoading}
                      />
                      <Spinner
                        size="sm"
                        className={`${f.id === featureLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardHeader>Dashboard Sections</CardHeader>
        <CardBody className="fs--1">
          {dashboardSections?.length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Enabled</th>
                </tr>
              </thead>
              <tbody>
                {dashboardSections?.length ? renderDashboardSections(dashboardSections) : 'Failed to load sections'}
              </tbody>
            </Table>
          ) : (
            <div className="text-center">No dashboard sections to manage....</div>
          )}
        </CardBody>
      </Card>
      <Card className="mb-4">
        <CardHeader>Vendors</CardHeader>
        <CardBody className="fs--1">
          {vendors?.filter(item => item.type === 'vendor').length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Enabled</th>
                </tr>
              </thead>
              <tbody>{renderVendorList(vendors, 'vendor')}</tbody>
            </Table>
          ) : (
            <div className="text-center">No vendors to manage....</div>
          )}
        </CardBody>
      </Card>
      <Card className="mb-4">
        <CardHeader>Status.io Bypass</CardHeader>
        <CardBody className="fs--1">
          {vendorsLoadError ? (
            <div className="text-center text-danger">
              Failed to load status.io vendors. Refresh the page to try again.
            </div>
          ) : statusIoVendors.length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Bypass status.io check</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>{renderStatusIoBypassList(statusIoVendors)}</tbody>
            </Table>
          ) : (
            <div className="text-center">No status.io vendors to manage.</div>
          )}
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardHeader>ODD Vendors</CardHeader>
        <CardBody className="fs--1">
          {vendors?.filter(item => item.type === 'odd-vendor').length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Enabled</th>
                </tr>
              </thead>
              <tbody>{renderVendorList(vendors, 'odd-vendor')}</tbody>
            </Table>
          ) : (
            <div className="text-center">No vendors to manage....</div>
          )}
        </CardBody>
      </Card>

      <TenantSettings />
    </>
  );
}
